import { render, staticRenderFns } from "./Bordereau.vue?vue&type=template&id=5f4d3ca8&"
import script from "./Bordereau.vue?vue&type=script&lang=js&"
export * from "./Bordereau.vue?vue&type=script&lang=js&"
import style0 from "./Bordereau.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Bordereau.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports